import React from 'react'

export const KDPExclusiveBadge = () => {
    return (
        <div>
            <div
                style={{ fontSize: '0.6em', lineHeight: '0.6em' }}
                className="font-normal ml-2 bg-blue-50 border-1 py-2 px-1.5 rounded-full text-blue-600 border-blue-600"
            >
                KDP Exclusive
            </div>
        </div>
    )
}
